import appInitState from './AppInitState';
import { IAppReducer } from '../Interfaces/IAppReducer';
import { userReducer } from './User';
import { IAction } from '../../../__core/Interfaces/IAction';
import { IEvent } from '../../../__core/Interfaces/IEvent';
import { IUser } from '../Interfaces/IUser';

type AppReducerAction = IAction<IUser> | IEvent;

export const appReducer = (
  state: IAppReducer = appInitState,
  action: AppReducerAction
): IAppReducer => {
  return {
    user: userReducer(state.user, action as IAction<IUser>),
  };
};
